import { NativeDateAdapter } from '@angular/material/core';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const MONTH_YEAR_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY'
  },
  display: {
    dateInput: 'inputMonthYear',
    monthYearLabel: 'monthYearLabel',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const DASH_FORMAT = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'inputDashDates',
    monthYearLabel: 'monthYearLabel',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export class DatepickerAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: string): string {
    switch (displayFormat) {
      case 'inputMonthYear':
        return format(date, 'MM/yyyy');
      case 'inputDashDates':
        return format(date, 'dd-MM-yyyy');
      case 'monthYearLabel':
      case 'MM':
      case 'LL':
        return format(date, 'MMMM yyyy', { locale: es });
      default:
        return date.toDateString();
    }
  }
}
